import { FontWeight } from '@pasteltech/theme-provider'
import { memo } from 'react'
import { styled } from 'styled-components'
import { DeepNullable, ScreenQuery } from '../../utilities'

const NotableItemListContainer = styled.div`
  display: flex;
  padding: 150px 0px;
  width: 75%;
  margin: 0 auto;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.sizes.spacings.xxxxl}px;
  ${ScreenQuery.mobile} {
    width: 90%;
    padding: 50px 0px;
  }
  ${ScreenQuery.tablet} {
    width: 80%;
    padding: 100px 0px;
  }
`
const NotableItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${({ theme }) => theme.sizes.spacings.sm}px;
  align-self: stretch;
`
const NotableItemName = styled.div`
  color: ${({ theme }) => theme.colors.text.high};
  font-size: ${({ theme }) => theme.sizes.fontSize.heading3}px;
  font-weight: ${FontWeight.bold};
`
const NotableItemDescription = styled.div`
  color: ${({ theme }) => theme.colors.text.medium};
  font-size: ${({ theme }) => theme.sizes.fontSize.subtitle}px;
  font-weight: ${FontWeight.medium};
`
type NotableItem = null | DeepNullable<{
  id: string
  name: string
  description: string
}>
type Props = {
  data: NotableItem[]
}
export const NotableItemList = memo(({ data }: Props) => {
  return (
    <NotableItemListContainer>
      {data.map((item) => (
        <NotableItemContainer key={item?.id}>
          <NotableItemName>{item?.name}</NotableItemName>
          <NotableItemDescription>{item?.description}</NotableItemDescription>
        </NotableItemContainer>
      ))}
    </NotableItemListContainer>
  )
})

NotableItemList.displayName = 'NotableItemList'
